<template>
  <div class="smartrewards-root">
    <h2 class="smartrewards-title">XigFor SmartRewards™ Program — Terms & Conditions</h2>
    <div class="smartrewards-date">Effective Date: September 10, 2025</div>
    
    <div class="smartrewards-section">
      <h3>I. Plan Overview</h3>
      <p>XigFor SmartRewards™ is designed for U.S. users to boost transaction activity and repurchase rates within regulatory compliance. The program operates on a voluntary basis (Opt-in/Opt-out) and prioritizes data transparency and risk management.</p>
    </div>

    <div class="smartrewards-section">
      <h3>II. Participation and Withdrawal</h3>
      <ul>
        <li>Seller: When listing an item, you can choose to "Participate/Do Not Participate". By default, you will participate. You can modify the setting at any time without a cooldown period.</li>
        <li>Buyer: After purchasing the product in the program, the corresponding reward task can be automatically activated after agreeing to the terms and conditions and authorization.</li>
      </ul>
    </div>

    <div class="smartrewards-section">
      <h3>III. Tasks and qualified orders</h3>
      <ul>
        <li>When a buyer first meets the eligibility criteria for a purchase, the system will generate a reward mission for the buyer-seller pair.</li>
        <li>Only verified orders that have not been refunded or canceled can be counted toward your task progress. Returns, cancellations, or abnormal transactions may result in adjusted or canceled rewards.</li>
      </ul>
    </div>

    <div class="smartrewards-section">
      <h3>IV. Incentives for first purchase and repeat purchase</h3>
      <ul>
        <li>First purchase: The buyer gets a coupon for a percentage of the order amount, the seller gets merchant points, and the platform injects the reward pool proportionally for future incentives.</li>
        <li>Follow-up purchases: When the buyer repurchases on the platform, they will receive coupons and achievement progress updates. The seller and any previous sellers associated with this buyer will earn merchant points according to the rules.</li>
        <li>Progress tracking: View progress bar color and updates within the app (for growth stages, not a guarantee of earnings).</li>
      </ul>
    </div>

    <div class="smartrewards-section">
      <h3>5. Points, Coupons and Exchanges</h3>
      <ul>
        <li>Buyer coupons: Valid only for products participating in the program. They expire automatically after the specified period.</li>
        <li>Merchant points: Withdrawals can be claimed once the progress threshold displayed in the app is reached. If not reached, the points can be used for in-app deductions such as ads and traffic after a certain period.</li>
        <li>The platform will periodically display applicable thresholds, validity periods, and availability scope within the application.</li>
      </ul>
    </div>

    <div class="smartrewards-section">
      <h3>VI. Risk and Compliance Control</h3>
      <ul>
        <li>Rewards for activities such as unusual refunds, fake orders, fraud, and abuse of coupons will be suspended, adjusted, or revoked to prevent arbitrage and abuse.</li>
        <li>The platform may restrict participation eligibility for specific categories or high-risk merchants based on risk status.</li>
      </ul>
    </div>

    <div class="smartrewards-section">
      <h3>VII. BUDGET AND ADJUSTMENT</h3>
      <ul>
        <li>The platform will set an annual or periodic budget cap for rewards and discounts. When the budget reaches the cap, the platform may adjust, reduce, or postpone the distribution with prior notice.</li>
        <li>Legally awarded rewards that have been granted but not revoked are not retroactive.</li>
      </ul>
    </div>

    <div class="smartrewards-section">
      <h3>VIII. PRIVACY AND DATA USE</h3>
      <ul>
        <li>This program complies with applicable U.S. federal and state privacy laws (including the CCPA). Scenarios involving data exchange in exchange for benefits will be disclosed as "financial incentives" in compliance with regulations and require user consent.</li>
        <li>We do not sell personal information; user data is only used to identify, assign and verify rewards; users can withdraw their consent and exit the program at any time.</li>
      </ul>
    </div>

    <div class="smartrewards-section">
      <h3>IX. TAXES AND DISPUTES</h3>
      <ul>
        <li>Tax obligations arising from reward redemption or in-site deductions shall be borne by the recipient.</li>
        <li>Users may file a dispute through customer service within 15 business days. Disputes will be resolved through negotiation first, and if no agreement is reached, they will be arbitrated under the laws of Delaware.</li>
      </ul>
    </div>

    <div class="smartrewards-section">
      <h3>X. Clause Update and Effectiveness</h3>
      <ul>
        <li>For major clause changes, the platform will notify users at least 30 days in advance via email, in-site notifications, or official website announcements. The version number and effective date will be recorded simultaneously.</li>
        <li>These terms, together with the in-app display rules, constitute SmartRewards' user agreement.</li>
      </ul>
    </div>

    <div class="smartrewards-section">
      <h3>Contact Information for SmartRewards™ Program</h3>
      <p>If you have any questions, complaints, or requests related to rewards, points, or these Terms & Conditions, please contact:</p>
      <p><strong>Email:</strong> <a href="mailto:xigfor@gmail.com">xigfor@gmail.com</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartRewards',
}
</script>

<style scoped>
.smartrewards-root {
  max-width: 900px;
  margin: 40px auto;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.06);
  padding: 36px 28px 48px 28px;
  font-family: 'Poppins', Arial, sans-serif;
  color: #232323;
}
.smartrewards-title {
  font-family: 'Sansita', Arial, sans-serif !important;
  font-size: 2.1rem;
  font-weight: 900;
  margin-bottom: 0.2em;
  color: #ff5e62;
}
.smartrewards-date {
  color: #888;
  font-size: 1.08rem;
  margin-bottom: 18px;
}
.smartrewards-section {
  margin-bottom: 28px;
}
.smartrewards-section h3 {
  font-family: 'Sansita', Arial, sans-serif !important;
  font-size: 1.18rem;
  font-weight: bold;
  margin-bottom: 8px;
  color: #232323;
}
.smartrewards-section p, .smartrewards-section ul, .smartrewards-section ol {
  font-size: 1.05rem;
  color: #444;
  line-height: 2;
  margin-bottom: 0;
}
.smartrewards-section ul, .smartrewards-section ol {
  padding-left: 22px;
  margin-bottom: 0;
}
.smartrewards-section li {
  margin-bottom: 6px;
}
@media (max-width: 600px) {
  .smartrewards-root {
    padding: 16px 4px 24px 4px;
  }
  .smartrewards-title {
    font-size: 1.3rem;
  }
  .smartrewards-section h3 {
    font-size: 1rem;
  }
}
</style>
